module.exports = __webpack_public_path__ + "static/media/Vietnam.236e8933.png";